export default __webpack_public_path__ + "static/media/testimonial_new_1.8e62f521.svg";